/**
 * Import all constants as an object.
 */
import * as ActionType from "../../constants/actionType";
import { modifyFiles } from '../../services/utility/modifyFiles';
import _ from 'lodash';

const INITIAL_STATE = {
  fileProgress: {},
  uploadedDocuments: []
}

const UploadFileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionType.SET_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...modifyFiles({}, action.payload),
        },
      }

    case ActionType.SET_UPLOAD_PROGRESS:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload.id]: {
            ...state.fileProgress[action.payload.id],
            progress: action.payload.progress,
          },
        },

      }

    case ActionType.SUCCESS_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload.id]: {
            ...state.fileProgress[action.payload.id],
            status: 1
          },
        },
        uploadedDocuments: action.payload.uploadedDocuments
      }

    case ActionType.FAILURE_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload]: {
            ...state.fileProgress[action.payload],
            status: 0,
            progress: 0,
          },
        },
      }
    case ActionType.CLOSE_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {},
      }

    case ActionType.RESET_UPLOAD_FILE: 
      return _.assign({}, state, {
        fileProgress: {},
        uploadedDocuments: []
      });

    default:
      return state
  }
}

export default UploadFileReducer
